import * as yup from 'yup';

export const phoneSchema = yup.string().phone('Phone is invalid').required('Phone is required');
